import { zoneTransformResponse as transformResponse } from "./transforms";
import Http from "./Http";
const PREFIX = "zones";

export function getZones(config) {
  const controller = new AbortController();
  config = { ...config, signal: controller.signal, transformResponse };
  const call = Http.get(PREFIX, config);

  return { call, controller };
}

export function checkZoneNameIsUnique(config) {
  const controller = new AbortController();
  config = { ...config, signal: controller.signal };
  const call = Http.get(`${PREFIX}/name-unique`, config);

  return { call, controller };
}

export function createZone(formData, config) {
  return Http.post(PREFIX, formData, config);
}
